<div [attr.data-test]="'feature-catalog'">
  <div class="catalog row" [ngClass]="[activeRoute]">
    @if (!firstPageLoad) {
      <div class="col-12">
        @if (isCpqEnabled && containsConfigurableProducts()) {
          @if (hasContractParams) {
            <app-access-control [notForViewer]="true" [description]="false">
              <ng-container ngProjectAs="[slot][nonViewerContent]">
                <app-contract-steps-bar [stepNo]="1"></app-contract-steps-bar>
              </ng-container>
            </app-access-control>
          }
        }
        @if (isSparePartsEnabled && !containsConfigurableProducts()) {
          <app-access-control [notForViewer]="true" [description]="false">
            <ng-container ngProjectAs="[slot][nonViewerContent]">
              @if ((isMyInstalledBaseFlowEnabled$ | async) === true) {
                <app-equipment-selection
                  [currentCart]="currentCart"
                  [systemDetails]="systemDetails"
                  [loading]="loadingCartDataInProgress">
                </app-equipment-selection>
              }
              @if ((isPredefinedEquipmentFlowEnabled$ | async) === true) {
                <h5 class="catalog__contact-message"
                  [innerHTML]="'catalog.contact-message' | translate: {email: storeContactEmail}"
                  [attr.data-test]="'catalog-contact-message'"></h5>
              }
            </ng-container>
          </app-access-control>
        }
      </div>
    }
    <div class="col-12 col-lg-3 catalog-navigation">
      <div class="catalog__header">
        @if (isRouteActive('catalog')) {
          <h1 class="catalog__title" [attr.data-test]="'title-catalogTitle'">{{ catalogTitle | translate }}</h1>
        }
        @if (isRouteActive('search-results')) {
          @if (firstPageLoad) {
            <div class="stripe catalog__title-stripe"></div>
          }
          @if (showResultsMessage()) {
            <div class="catalog__title">
              {{ 'search-results.search-summary' | translate:{count: pagination.numFound} }}
              <span [attr.data-test]="'desc-searchKeywords'" class="search__keyword">{{ '“' + params.q + '”' }}</span>
            </div>
          }
        }
        @if (isRouteActive('installed-base')) {
          @if (firstPageLoad) {
            <div class="stripe catalog__title-stripe"></div>
          }
          @if (!firstPageLoad && installBaseProduct) {
            <div class="catalog__title">
              <h5 class="margin-0">{{ 'install-base.products-for' | translate }}</h5>
              <h5 class="margin-0">{{ installBaseProduct.attributes.nameEnUs }}</h5>
            </div>
          }
        }
        <app-access-control>
          <ng-container ngProjectAs="[slot][content]">
            @if (getBlackFridayLabel()) {
              <div class="sticker__container">
                <img alt="{{ 'black-friday.sticker' | translate }}" [src]="blackFridaySticker">
              </div>
            }
          </ng-container>
        </app-access-control>
      </div>
      <button [attr.data-test]="'button-categoryTreeMobile'"
        class="button icon-arrow-down-small catalog-navigation-filter__button"
        (click)="filtersDropdownOpened = !filtersDropdownOpened">
        {{ 'category-tree.mobile-button-name' | translate }}
      </button>
      <div class="search-filters" [ngClass]="{'is-open': filtersDropdownOpened}">
        <app-category-tree
          [params]="params"
          [fetchedCategories]="fetchedCategories"
          [showLoader]="loading"
          [useNavigate]="isRouteActive('search-results') || isRouteActive('installed-base')">
        </app-category-tree>
        <app-access-control class="margin-bottom-0">
          <ng-container ngProjectAs="[slot][content]">

            @if (!firstPageLoad && this.equipmentTypeFilter.isApplicable
              && !noProductFound && !equipmentComponentFilterActive) {
              <app-equipment-type-filter
                [filter]="equipmentTypeFilter"
                [isEnhancedEquipmentTypeFilterEnabled]="(isEnhancedEquipmentTypeFilterEnabled$ | async) ?? false"
                [isPredefinedEquipmentFlowEnabled]="(isPredefinedEquipmentFlowEnabled$ | async) ?? false">
              </app-equipment-type-filter>
            }

            @if (!firstPageLoad && this.equipmentComponentFilter.isApplicable && equipmentComponentFilterActive) {
              <app-equipment-component-filter
                [filter]="equipmentComponentFilter">
              </app-equipment-component-filter>
            }

          </ng-container>
        </app-access-control>
        <app-filters
          [filters]="filters"
          [activeFilters]="params">
        </app-filters>
      </div>
    </div>
    <div class="col-12 col-lg-9">
      @if (!noProductFound) {
        <div>
          <div class="marked-filters__container">
            <app-marked-filters
              [filters]="filters"
              [equipmentTypeFilter]="equipmentTypeFilter"
              [equipmentComponentFilter]="equipmentComponentFilter"
              [equipmentComponentFilterActive]="equipmentComponentFilterActive"
              [isEnhancedEquipmentTypeFilterEnabled]="(isEnhancedEquipmentTypeFilterEnabled$ | async) ?? false"
              [systemDetails]="systemDetails"
              [emptyCatalog]="false">
            </app-marked-filters>
          </div>
          <div class="sort-by-container">
            @if (firstPageLoad) {
              <div class='stripe stripe-half stripe-tall'></div>
            }
            @if (!firstPageLoad) {
              <app-sort-by [isCatalogPage]=true [sort]="sort" [params]="params" [attr.data-test]="'dropdown-sort-by'"></app-sort-by>
              <app-layout-options class="desktop"
                [currentLayoutType]="currentLayoutType"
                (selected)="selectLayoutOption($event)">
              </app-layout-options>
            }
          </div>
        </div>
      }
      @if (firstPageLoad) {
        <div class="row" [attr.data-test]="'loader-products'">
          <div class="col-4">
            <app-product-loading-tile></app-product-loading-tile>
          </div>
          <div class="col-4">
            <app-product-loading-tile></app-product-loading-tile>
          </div>
          <div class="col-4">
            <app-product-loading-tile></app-product-loading-tile>
          </div>
        </div>
      }
      @if (isRouteActive('search-results') && noProductFound) {
        <div class="no-product-found">
          @if (isRouteActive('installed-base')) {
            <h5 [attr.data-test]="'desc-noPartsAvailable'">{{ 'install-base.no-parts-available' | translate }}</h5>
            <button [attr.data-test]="'button-proceedToHomepage'"
              type=button class="button button--primary" (click)="proceedToHomepage()">
              {{ 'install-base.proceed-to-homepage' | translate }}
            </button>
          } @else {
            <h5 [attr.data-test]="'desc-noSearchResults'">{{ 'search-results.no-results' | translate }}</h5>
            <button [attr.data-test]="'button-proceedToHomepage'"
              type=button class="button button--primary" (click)="proceedToCatalog()">
              {{ 'search-results.proceed-to-catalog' | translate }}
            </button>
          }
        </div>
      }
      @if (showNoProductFound()) {
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <app-marked-filters
              [filters]="filters"
              [equipmentTypeFilter]="equipmentTypeFilter"
              [equipmentComponentFilter]="equipmentComponentFilter"
              [equipmentComponentFilterActive]="equipmentComponentFilterActive"
              [isEnhancedEquipmentTypeFilterEnabled]="(isEnhancedEquipmentTypeFilterEnabled$ | async) ?? false"
              [systemDetails]="systemDetails"
              [emptyCatalog]="true">
            </app-marked-filters>
          </div>
        </div>
        <div class="no-product-found">
          <h5 [attr.data-test]="'desc-noProducts'">{{ 'product-list.no-products' | translate }}</h5>
        </div>
      }
      @if (!noProductFound) {
        <app-catalog-products
          [isUsStore]="isUsStore"
          [isCaStore]="isCaStore"
          [isMeaStore]="isMeaStore"
          [isSparePartsEnabled]="isSparePartsEnabled"
          [isCpqEnabled]="isCpqEnabled"
          [currentCart]="currentCart"
          [currentCartId]="currentCartId"
          [systemDetails]="systemDetails"
          [products]="abstractProducts"
          [layoutType]="currentLayoutType"
          [labels]="labels"
          [productsLoading]="loading"
          [activeRoute]="activeRoute"
          [contractParams]="contractParams"
          [loadingCartDataInProgress]="loadingCartDataInProgress"
          [isPredefinedEquipmentFlowEnabled]="(isPredefinedEquipmentFlowEnabled$ | async) ?? false">
        </app-catalog-products>
      }
      @if (pagination && !noProductFound) {
        <div class="row">
          <app-pagination
            class="col-12"
            [numberOfPages]="pagination.maxPage"
            [itemsPerPage]="pagination.currentItemsPerPage">
          </app-pagination>
        </div>
      }
      @if (showNoConfigurationAvailableInfo()) {
        <div class="no-configuration">
          {{ 'catalog.not-yet-configuration' | translate }}
        </div>
      }
      <app-access-control>
        <ng-container ngProjectAs="[slot][content]">
          @if (isSparePartsCatalogAndHasProducts()) {
            <div class="spare-parts-price-disclaimer">
              {{ 'catalog.spare-parts-price-disclaimer' | translate }}
            </div>
          }
        </ng-container>
      </app-access-control>
    </div>
  </div>
  @if (!firstPageLoad && loading) {
    <div class="loader__overlay">
      <div class="loader__content">
        <div class="loading-animation"></div>
      </div>
    </div>
  }
</div>
